import { render } from "./Linda_page7.vue?vue&type=template&id=b9cb6782&scoped=true"
import script from "./Linda_page7.vue?vue&type=script&lang=js"
export * from "./Linda_page7.vue?vue&type=script&lang=js"

import "./Linda_page7.vue?vue&type=style&index=0&id=b9cb6782&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9cb6782"]])

export default __exports__